import { useAuth } from '@/contexts/AuthContext';
import { EPermission } from '@/enums/EPermission';
import { EUserRole } from '@/enums/EUserRole';

const hasPermission = (per: EPermission): boolean => {
  const { userInfo } = useAuth();
  return userInfo?.permissions?.includes(per) || false;
};

const isFullAccess = () => {
  const { userInfo } = useAuth();
  const role = userInfo?.role;
  return (
    role &&
    [EUserRole.Manager, EUserRole.SuperAdmin, EUserRole.Admin].includes(role)
  );
};

const isManager = () => {
  const { userInfo } = useAuth();
  const role = userInfo?.role;
  return role && [EUserRole.Manager, EUserRole.SuperAdmin].includes(role);
};

const isAdmin = () => {
  const { userInfo } = useAuth();
  const role = userInfo?.role;
  return role && [EUserRole.Admin, EUserRole.SuperAdmin].includes(role);
};

const isEmployee = () => {
  const { userInfo } = useAuth();
  return userInfo?.role === EUserRole.Employee;
};

const isWareHouse = () => {
  const { userInfo } = useAuth();
  const role = userInfo?.role;
  return role && [EUserRole.Warehouse, EUserRole.Observe].includes(role);
};

const isObServe = () => {
  const { userInfo } = useAuth();
  const role = userInfo?.role;
  return role && [EUserRole.Observe].includes(role);
};

const isSuperAdmin = () => {
  const { userInfo } = useAuth();
  return userInfo?.role == EUserRole.SuperAdmin;
};

export {
  hasPermission,
  isFullAccess,
  isWareHouse,
  isManager,
  isEmployee,
  isAdmin,
  isSuperAdmin,
  isObServe,
};
